var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChampionxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 32,
    viewBox: "0 0 242 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_1558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.859 18.5586V13.9756L220.166 7.38257C219.857 7.0251 219.408 6.81958 218.935 6.81958H211.455L221.107 17.9954C221.416 18.3528 221.865 18.5584 222.337 18.5584L225.859 18.5586Z",
    fill: "#DC4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.455 32.0002H218.934C219.407 32.0002 219.857 31.7942 220.166 31.4359L225.859 24.8296V20.2466H222.338C221.865 20.2466 221.416 20.4523 221.107 20.8104L211.455 32.0002Z",
    fill: "#DC4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.952 6.81958H234.471C233.999 6.81958 233.55 7.0251 233.241 7.38257L227.547 13.9756V18.5584H231.07C231.542 18.5584 231.991 18.3528 232.3 17.9954L241.952 6.81958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.547 20.2466V24.8293L233.241 31.4356C233.55 31.794 234 31.9999 234.473 31.9999H241.952L232.3 20.8102C231.992 20.4521 231.542 20.2463 231.069 20.2463L227.547 20.2466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4283 24.0262C17.4791 25.7986 15.8311 26.8245 13.1771 26.8245C9.28994 26.8245 6.35861 23.6368 6.35861 19.4096V19.3395C6.35861 15.1523 9.28972 11.9949 13.1771 11.9949C15.3264 11.9949 17.2005 12.8256 19.2532 14.6879L19.4851 14.8986L23.3184 10.4787L23.1133 10.2766C20.3896 7.5945 17.3357 6.39844 13.2118 6.39844C5.73412 6.39844 0.0952148 11.9921 0.0952148 19.4096V19.4799C0.0952148 26.8577 5.64368 32.4209 13.0013 32.4209C17.3366 32.4209 20.3198 31.122 23.2978 27.9365L23.4993 27.7213L19.6456 23.8284L19.4283 24.0262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8132 16.5413H32.4593V6.81958H26.4419V32H32.4593V22.138H41.8132V32H47.8306V6.81958H41.8132V16.5413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1146 15.4001H57.203L50.8306 32.0001H56.8499L58.313 28.1106H67.8729L69.3355 32.0001H75.4871L69.1146 15.4001ZM60.0525 23.485L63.0927 15.4021L66.1327 23.485H60.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4662 13.7119L63.1587 -0.114014L57.8511 13.7119H68.4662Z",
    fill: "#DC4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.225 6.42993C103.899 6.42993 101.214 7.75629 99.0306 10.4812C97.5418 7.86409 94.9456 6.42993 91.6671 6.42993C88.104 6.42993 85.9751 8.23034 84.5188 10.0408V6.81955H78.3032V32H84.5188V17.8955C84.5188 14.3971 86.4523 12.1363 89.4447 12.1363C92.3983 12.1363 94.0924 14.1849 94.0924 17.7566V32H100.308V17.8955C100.308 14.3433 102.196 12.1363 105.234 12.1363C108.231 12.1363 109.882 14.1487 109.882 17.8027V32H116.097V16.0893C116.097 10.0408 112.781 6.42993 107.225 6.42993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.235 6.81958H120.891V32H126.909V24.6297H130.709C136.928 24.6297 140.947 21.1206 140.947 15.6898V15.6191C140.947 10.2736 137.135 6.81958 131.235 6.81958ZM126.909 12.3108H130.779C133.372 12.3108 134.86 13.5551 134.86 15.7246V15.7948C134.86 17.8368 133.262 19.2086 130.884 19.2086H126.909V12.3108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.201 32H150.219V28.4273V6.81958H144.201V32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.962 6.39844C159.45 6.39844 153.565 12.1136 153.565 19.4096V19.4799C153.565 26.8577 159.294 32.4209 166.892 32.4209C174.405 32.4209 180.29 26.7055 180.29 19.4094V19.3393C180.29 11.9619 174.56 6.39844 166.962 6.39844ZM159.828 19.3395C159.828 15.1523 162.865 11.9949 166.892 11.9949C170.959 11.9949 174.026 15.1825 174.026 19.4096V19.4799C174.026 23.667 170.99 26.8245 166.962 26.8245C162.895 26.8245 159.828 23.6368 159.828 19.4096V19.3395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.268 6.42993C194.298 6.42993 191.89 7.62299 189.935 10.0708V6.81976H183.719V32.0002H189.935V17.8955C189.935 14.3971 191.978 12.1363 195.138 12.1363C198.315 12.1363 200.064 14.1487 200.064 17.8027V32H206.28V16.0893C206.28 10.1313 202.827 6.42993 197.268 6.42993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_1558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241.452,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampionxLogo);
export default __webpack_public_path__ + "static/media/championx-logo.e848388bee29c0f40b7b7bb4bbb2d2a7.svg";
export { ForwardRef as ReactComponent };